import { useTheme } from "@emotion/react";
import { ClockGraphic } from "../config/config";
import { PlannedPhase } from "../pages/Room";
import { getThemeColor } from "../utils/color";
import { RingSegment } from "./RingSegment";

/**
 * Displays the upcoming phases of a session,
 * @param param0 
 */
export const PhaseRingSegments = ({ upcomingPhases, totalSessionDuration, passedTime, graphic }: { graphic: ClockGraphic<number>, passedTime?: number, totalSessionDuration?: number, upcomingPhases: PlannedPhase[] }) => {
    const theme = useTheme() as any;
    const degreeEndPassedTime = upcomingPhases[0]
        ? // equals degreeStart of first upcoming phase
        - (upcomingPhases[0].displayPhaseStartToSessionEnd || 0) / graphic.fullCircleDuration
        : // no upcoming phases: PassedTime = full session => degreeEnd = 0
        0;

    let degreeStartPassedTime = -1;
    if (passedTime !== undefined) {
        degreeStartPassedTime = degreeEndPassedTime - (passedTime / graphic.fullCircleDuration);
    } else if (totalSessionDuration !== undefined) {
        degreeStartPassedTime =  - (totalSessionDuration / graphic.fullCircleDuration);
    }
    if (degreeStartPassedTime < -1) degreeStartPassedTime = -1;

    const colorPassedTime = getThemeColor(theme, graphic.colorPassedTime || "twa-grey");
    return (<>
        <RingSegment
            key="session-passed-time-outer"
            className="layer"
            color={colorPassedTime}
            degreeStart={degreeStartPassedTime}
            degreeEnd={degreeEndPassedTime}
            radiusOuter={graphic.circleRadius}
        />
        {/* <RingSegment
            key="session-passed-time-outer"
            className="layer"
            color={colorPassedTime}
            degreeStart={degreeStartPassedTime}
            degreeEnd={degreeEndPassedTime}
            radiusOuter={graphic.circleRadius}
            radiusInner={(graphic.circleRadius || 58) - 10}
        />
        <RingSegment
            key="session-passed-time-inner"
            className="layer"
            color={colorPassedTime}
            degreeStart={degreeStartPassedTime}
            degreeEnd={degreeEndPassedTime}
            radiusOuter={20}
            radiusInner={10}
        />
        <RingSegment
            key="session-passed-time-middle"
            className="layer"
            color={colorPassedTime}
            degreeStart={degreeStartPassedTime}
            degreeEnd={degreeEndPassedTime}
            radiusOuter={(graphic.circleRadius || 58) / 2 + 10}
            radiusInner={(graphic.circleRadius || 58) / 2 }
        /> */}
        {
            upcomingPhases.filter(phase => !phase.hiddenOnClock).map(phase => {
                //use negative degrees: 0 = top. -0.25 = left
                const degreeEnd = -(phase.displayPhaseEndToSessionEnd || 0) / graphic.fullCircleDuration;
                const degreeStart = -(phase.displayPhaseStartToSessionEnd || 0) / graphic.fullCircleDuration;
                const color = getThemeColor(theme, phase.color);
                return <RingSegment
                    key={phase.name + "_" + degreeEnd}
                    className="layer"
                    color={color}
                    degreeStart={degreeStart}
                    degreeEnd={degreeEnd}
                    radiusOuter={graphic.circleRadius}
                />;
            })
        }
    </>);
}